/**
 * Decide what a click on the Edit/Cancel toggle should do, so a "close
 * confirmation" only appears when there are unsaved edits.
 *
 * - Not editing            → 'enter'   (start editing)
 * - Editing, unsaved edits → 'confirm' (ask before discarding)
 * - Editing, no edits      → 'discard' (close immediately)
 *
 * @param editMode - Whether the budget is currently in edit mode
 * @param hasChanges - Whether there are unsaved tracked changes
 * @returns The action the Edit/Cancel toggle should take
 * @example
 * resolveEditToggle(true, true)   // 'confirm'
 * resolveEditToggle(true, false)  // 'discard'
 * resolveEditToggle(false, false) // 'enter'
 */
export type EditToggleAction = 'enter' | 'confirm' | 'discard'

export const resolveEditToggle = (editMode: boolean, hasChanges: boolean): EditToggleAction => {
  if (!editMode) return 'enter'
  return hasChanges ? 'confirm' : 'discard'
}
